<template>

    <ul class="om-radio__list flex wrap sb" :class="[(`om-radio__list--${variant}`)]">
      <li
        v-for="item in items"
        @click.prevent="changeAction( item.value )"
        :class="[choosedValue === item.value ? 'active': '', variantClass]"
        :title="(variant === 'check' && item.name ? item.name : null)">
        <span v-if="variant === 'button' && typeof item.name !== 'undefined'">{{ item.name }}</span>
        <span v-else-if="variant === 'button' && typeof item.value !== 'undefined'">{{ item.value }}</span>
      </li>
    </ul>
</template>
<script>
  export default {
    name: 'radio',
    data () {
      return {
        debug: false,
        choosedValue: null,
        reveal: false,
        variantClass: null
      }
    },
    props: {
      items: Array,
      variant: {
        type: String,
        'default': 'button',
        validator: (value) => {
          let allowedValues = ['button', 'check']
          return allowedValues.indexOf(value) !== -1
        }
      },
      disabled: {
        type: Boolean,
        'default': false
      },
      initialValue: {
        'default': null
      }
    },
    mounted () {
      this.variantClass = 'om-radio--' + this.variant
      if (this.initialValue !== null) {
        this.choosedValue = this.initialValue
      } else if (typeof this.items !== 'undefined' && this.items !== null && typeof this.items[0] !== 'undefined') {
        this.choosedValue = typeof this.items[0].name !== 'undefined' ? this.items[0].name : (typeof this.items[0].value !== 'undefined' ? this.items[0].value : this.items[0])
      }
    },
    methods: {
      changeAction (val) {
        if (this.disabled) {
          return false
        }
        this.reveal = false
        if (this.choosedValue !== val) {
          this.choosedValue = val
        } else {
          this.choosedValue = null
        }
        if (this.debug) console.log(this.choosedValue)
        this.$emit('change', this.choosedValue)
      }
    }
  }
</script>

<style lang="scss" src="../../../assets/scss/reusable/radio.scss"></style>


// WEBPACK FOOTER //
// Radio.vue?79d99480